import React, { ReactElement } from "react";
import styles from "./featureWithImage.module.scss";
import classNames from "classnames";
import { SectionHeader } from "../sectionHeader";

export const FeatureWithImage = (props: Props): ReactElement => {
  return (
    <section
      className={styles.base}
      style={{
        backgroundImage: `url(${props.bgImage})`,
      }}
      id={props.anchorTag}
    >
      <div
        className={classNames(styles.wrapper, {
          [styles.vertical]:
            ["top", "bottom"].indexOf(props.imagePosition) > -1,
          [styles.horizontal]:
            ["top", "bottom"].indexOf(props.imagePosition) == -1,
        })}
      >
        <div className={classNames(styles.image, styles[props.imagePosition])}>
          <img src={props.imageUrl} alt="" loading="lazy" />
        </div>
        <div className={styles.meta}>
          <SectionHeader
            title={props.title}
            desc={props.desc}
            badgeIcon={props.badgeIcon}
            badgeText={props.badgeText}
            size={props.size}
          />
        </div>
      </div>
    </section>
  );
};

interface Props {
  imagePosition: "left" | "right" | "top" | "bottom";
  bgImage?: string;
  imageUrl: string;
  title: string;
  desc: string;
  badgeIcon?: React.ElementType;
  badgeText?: string;
  size: "xs" | "sm" | "md";
  anchorTag?: string;
}
